module.exports = __webpack_public_path__ + "static/media/puppie-final.5564163a.svg";